import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=25c3cb75&"
import script from "./Editor.vue?vue&type=script&lang=js&"
export * from "./Editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25c3cb75')) {
      api.createRecord('25c3cb75', component.options)
    } else {
      api.reload('25c3cb75', component.options)
    }
    module.hot.accept("./Editor.vue?vue&type=template&id=25c3cb75&", function () {
      api.rerender('25c3cb75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Pages/Editor.vue"
export default component.exports